import Tracker from "./tracker.js";

const forwardedTracker = Symbol("ForwardTracker.tracker");

class ForwardTracker extends Tracker {
    constructor(tracker) {
        super();

        this[forwardedTracker] = tracker;
        tracker.listenNeedsUpdate(() => this.protected_needsUpdate());
    }

    protected_startUpdate() {
        return this[forwardedTracker].startUpdate();
    }

    protected_finishUpdate() {
        this[forwardedTracker].finishUpdate();
    }
}

export default ForwardTracker;
